export default "__VITE_ASSET__CRJN$C90__"